import { defineCopy } from "@tami/core/intl";

import { HOME_COPY_EN_US } from "./en-us/home.copy";
import { HOME_COPY_ES_ES } from "./es-es/home.copy";

/**
 * Texto da home pública (só-web), por seção. Fica em português; a tradução para
 * en/es vem depois, por catálogo. Interpolação e plural são funções.
 */
export const HOME_COPY_PT_BR = {
  taglines: {
    connect: {
      before: "Conecte todos os pontos da sua vida de Creator em,",
      italic: "um só lugar.",
    },
    transformLine1: {
      before: "Transforme a desorganização,",
      italic: "produtividade.",
    },
    transformLine2: {
      before: "E a incerteza financeira em",
      italic: "controle total.",
    },
    closing: {
      before: "Você cria.",
      italic: "A Tãmi cuida do resto.",
    },
    testimonials: {
      before: "Não é a gente que fala.",
      italic: "São eles.",
    },
  },

  hero: {
    stickersAlt: "Stickers decorativos",
    headingLead: "Sua carreira de Creator,",
    headingHighlights: ["Organizada.", "Profissional.", "Rentável."],
    description:
      "Tãmi é a ferramenta para que você seja o Creator que sempre quis ser: eficiente, lucrativo e com tempo para o que realmente importa.",
    photoAlt: "mulheres jovens vestindo moda dos anos 2000",
    scrollDownAria: "Rolar para baixo",
    /** Dados de demonstração dos cards que flutuam ao redor da foto. */
    events: [
      { title: "Gravação externa - Publi X", timeRange: "16:30 - 17:30" },
      { title: "Gravar conteúdos orgânicos", timeRange: "19:00 - 22:00" },
      { title: "Consulta com Fonoaudióloga", timeRange: "10:00 - 12:00" },
      { title: "Chamada de alinhamento", timeRange: "08:30 - 09:30" },
    ],
  },

  navigationButtons: {
    content: "Conteúdo",
    finances: "Finanças",
    agenda: "Agenda",
    team: "Equipe",
    createAccount: "Crie sua conta",
    iconAlt: "Ícone Tami",
  },

  features: {
    heading: {
      before: "Não sabe por",
      where: "onde",
      start: "começar",
      afterStart: "?",
      followSteps: "siga os passos da",
      brand: "Tãmi",
      pro: "Pro",
    },
    cta: "Já quero meu acesso",
    steps: [
      {
        title: "Tempestade criativa",
        description:
          "Onde tudo começa: uma ideia, um surto, um insight no meio do nada. O segredo? Anotar antes que suma.",
      },
      {
        title: "Avaliação intuitiva",
        description:
          "É hora de refletir: essa ideia faz sentido mesmo? Combina comigo, com meu momento, com quem me segue?",
      },
      {
        title: "Planejamento estratégico",
        description:
          "A ideia passou no filtro? Agora ela precisa de formato, dados, objetivo e plano de ação.",
      },
      {
        title: "Implementação real",
        description:
          "Mão na massa! É o momento de criar, gravar, revisar ou acompanhar quem vai executar.",
      },
      {
        title: "Replay criativo",
        description:
          "O conteúdo foi pro mundo. E agora? Analisar, entender o que funcionou e usar como combustível para a próxima ideia.",
      },
    ],
  },

  featuresSession: {
    cards: [
      { title: "Finanças", subtitle: "do creator" },
      { title: "Calculadora", subtitle: "de publis" },
      { title: "Calendário", subtitle: "do creator" },
    ],
    imageAlt: "Grupo de celulares mostrando funcionalidades do Tãmi",
  },

  bannerImage: {
    imageAlt:
      "Pessoa trabalhando com iPad mostrando o calendário do creator no Tãmi",
    glassCard: {
      titleLine1: "Liberte-se das planilhas",
      titleLine2: "e anotações soltas.",
      paragraphLine1: "Centralize sua vida de creator e",
      paragraphLine2: "foque no que realmente importa.",
      paragraphBold: "Criar.",
      cta: "Crie sua conta",
      iconAlt: "Ícone Tami",
    },
  },

  bannerPhone: {
    title: "Nunca mais perca uma ideia ou um prazo.",
    imageAlt: "Aplicativo Tami no iPhone com fundo gradiente",
    text: "Com a Tãmi, você tem uma assistente inteligente que te acompanha em qualquer lugar.",
    cta: "Crie sua conta",
  },

  bannerImgBody: {
    imageAlt: "Promotion Footer",
    logoAlt: "Logo Tãmi",
    taglineLine1: "Uma solução completa, feita no Brasil,",
    taglineLine2: "para impulsionamento de Creators.",
  },

  heroScrollDemo: {
    rainbowCardAlt: "Rainbow card",
    tags: {
      content: "Conteúdo",
      finances: "Finanças",
      agenda: "Agenda",
      team: "Equipe",
    },
    createAccount: "Crie sua conta",
    iconAlt: "Ícone Tami",
    /** Texto alternativo dos slides, na ordem de `imgsDesk`. */
    desktopSlides: [
      "Dashboard - Painel Principal",
      "Dashboard - Visão Detalhada",
      "Desempenho do Creator - Página 1",
      "Desempenho do Creator - Página 2",
      "Desempenho do Creator - Página 3",
      "Calculadora de Publ - Página 1",
      "Calculadora de Publ - Página 2",
      "Finanças do Creator - Página 1",
      "Finanças do Creator - Página 2",
      "Finanças do Creator - Página 3",
      "Central de Campanhas",
      "Tarefas e Lembretes",
      "Notas do Creator",
      "Calendário",
      "Fluxo da Semana",
    ],
    /** Texto alternativo dos slides, na ordem de `imgsMobile`. */
    mobileSlides: [
      "Dashboard - Painel Principal",
      "Dashboard - Visão Detalhada",
      "Dashboard - Análise Avançada",
      "Dashboard - Relatórios",
      "Desempenho do Creator - Página 1",
      "Desempenho do Creator - Página 2",
      "Desempenho do Creator - Página 3",
      "Desempenho do Creator - Página 4",
      "Calculadora de Publ - Página 1",
      "Calculadora de Publ - Página 2",
      "Calculadora de Publ - Página 3",
      "Finanças do Creator - Página 1",
      "Finanças do Creator - Página 2",
      "Finanças do Creator - Página 3",
      "Finanças do Creator - Página 4",
      "Central de Campanhas",
      "Tarefas e Lembretes",
      "Notas do Creator",
      "Calendário",
      "Fluxo da Semana",
    ],
  },

  infoMessage: {
    titleBold1: "Cansou",
    titleDe: "de",
    titleTools: "ferramentas",
    titleThatDont: "que não te",
    titleBold2: "entendem",
    titleQuestion: "?",
    bodyBefore: "Enquanto outras plataformas tentavam",
    bodyItalic: "enfiar o creator",
    bodyAfter:
      "num modelo todo engessado de empresa, a Tãmi nasceu da nossa bagunça real, da rotina corrida, dos prazos apertados e da cabeça cheia de quem vive de criar.",
    tagline: "Chegou pra organizar o caos de quem tá nesse corre.",
    cta: "Quero me organizar com a Tãmi",
  },

  blackFriday: {
    label: "TÃMI TÁ NA BLACK!",
    iconAlt: "Tãmi",
  },

  testimonials: {
    sectionAria: "Depoimentos de creators",
    memberSince: "na Tãmi desde",
  },

  pricing: {
    title: {
      line1: "Nossos preços, na lata,",
      line2: "sem taxas extras.",
    },
    subtitle: "A Tãmi é para criadores em diferentes momentos de carreira.",
    audienceAria: "Escolha o tipo de conta",
    audienceTabs: {
      creator: "Sou Creator",
      agency: "Sou Collab",
    },
    cycleAnnualAria: "Cobrança anual",
    monthly: "Mensal",
    annual: "Anual",
    bridge: {
      toCreator: "Cria conteúdo por conta própria? Os planos individuais estão em “Sou Creator”.",
      toCollab: {
        before: "Administra creators? Veja o",
        bold: "Tãmi Enterprise",
        after: "em “Sou Collab”.",
      },
    },
  },

  planCard: {
    mostChosen: "Mais escolhido",
    onRequestDescription: "Nosso time monta a proposta certa com você.",
    free: "Grátis",
    freeForever: "Para sempre, com os tetos abaixo.",
    perYear: "/ano",
    perMonth: "/mês",
    includedFree: "O que entra",
    includedPaid: "O que você leva",
  },

  benefits: {
    title: "Será que ela é pra você?",
    items: {
      balance: {
        title: "Maior Equilíbrio Vida-Trabalho",
        description: "Facilita a gestão do tempo, proporcionando mais equilíbrio entre vida pessoal e profissional.",
      },
      empowerment: {
        title: "Empoderamento Profissional",
        description: "Oferece ferramentas para uma gestão mais estratégica e crescimento na carreira.",
      },
      stress: {
        title: "Redução do Estresse",
        description: "Diminui a sobrecarga administrativa e o estresse associado à gestão de múltiplos projetos.",
      },
      clarity: {
        title: "Maior Clareza e Objetividade",
        description: "Ajuda a definir e alcançar metas claras, proporcionando foco e direção.",
      },
      relationships: {
        title: "Fortalecimento de Relações Comerciais",
        description: "Melhora a gestão de parcerias e negociações, solidificando relacionamentos comerciais.",
      },
      growth: {
        title: "Crescimento Pessoal e Profissional",
        description: "Contribui para o desenvolvimento contínuo ao otimizar a gestão de atividades.",
      },
    },
  },

  planComparison: {
    title: "Compare linha por linha",
    subtitle: "Os números vêm dos limites configurados em cada plano.",
    caption: "Comparação de recursos e limites entre os planos da Tãmi",
    featureColumn: "Recurso",
  },

  priceOnRequest: {
    title: "Fale com a gente",
  },

  featureList: {
    seeLess: "Ver menos",
    seeMore: (count: number): string => `Ver mais ${count} itens`,
  },

  enterpriseCard: {
    seatsPreview: "você + 1 criador, e cresce quando precisar",
    onRequestDescription:
      "Pacote da Collab mais um valor por criador. Nosso time monta a proposta certa com você.",
    packageLabel: "Pacote da Collab",
    perYear: "/ano",
    perMonth: "/mês",
    perCreator: (formattedValue: string): string =>
      `+ ${formattedValue} por criador`,
    badge: "Para Collabs",
    logoAlt: "Tami Logo",
    intro:
      "Para Collabs que administram creators e as campanhas deles. Um único painel para a Collab inteira — e cada creator da Collab usa a Tãmi Pro completa, sem assinar separado.",
    ctaTalk: "Falar de Collab",
    bottomCta: {
      before: "Quero falar sobre a",
      bold: "Tãmi para Collabs",
    },
    bottomCtaSignUp: {
      before: "Quero a Tãmi para a minha",
      bold: "Collab!",
    },
    features: [
      {
        title: "Creators da Collab",
        description:
          "Cadastre e organize todos os creators da Collab em um painel só, com visão consolidada.",
      },
      {
        title: "Vínculo de creators",
        description:
          "Convide quem já usa a Tãmi ou crie contas novas para a Collab, com acesso controlado.",
      },
      {
        title: "Campanhas da Collab",
        description:
          "Acompanhe as campanhas de cada influenciador e o status das entregas em um lugar.",
      },
      {
        title: "Propostas da Collab",
        description:
          "Monte propostas comerciais somando o alcance de vários creators, exportando em PDF.",
      },
      {
        title: "Assinatura por assento",
        description:
          "Uma assinatura só para a Collab, com assentos que acompanham o crescimento da Collab.",
      },
      {
        title: "Tudo do Tãmi Pro",
        description:
          "Cada creator da Collab usa as ferramentas completas do plano Pro, sem assinar separado.",
      },
    ],
  },
} as const;

export const HOME_COPY = defineCopy(HOME_COPY_PT_BR, {
  "en-US": HOME_COPY_EN_US,
  "es-ES": HOME_COPY_ES_ES,
});
